import { BooleanFilter } from './TypeUtils';

const ALL_NON_WORD = /\W/g;
const ALL_SPACES = /\s/g;

function generateId(...strings: Array<undefined | string>): string;
function generateId(strings: undefined | string | Array<undefined | string>): string;
function generateId(
  first: undefined | string | ReadonlyArray<undefined | string>,
  ...others: ReadonlyArray<undefined | string>
): string {
  return (Array.isArray(first) ? first.concat(...others) : [first, ...others])
    .join(' ')
    .replace(ALL_NON_WORD, ' ')
    .toLowerCase()
    .split(' ')
    .map(s => s.trim())
    .filter(BooleanFilter)
    .join('-')
    .replace(ALL_SPACES, '-');
}

export { generateId };
